<template>
  <section>
    <div class="title-container">
      <h3>Instructies voor de printshop</h3>
    </div>

    <textarea
      placeholder="Typ hier uw instructies."
      :value="instruction"
      @input="$emit('update', $event.target.value)"
      :class="{ 'hide-overflow': !active }"
    ></textarea>
    <div class="sub-btn-holder">
      <button
        class="main-button back"
        @click="$emit('close')"
        v-show="!hideSpecs"
      >
        Terug naar specificaties
      </button>
    </div>
  </section>
</template>

<script>
export default {
  props: ['instruction', 'hideSpecs', 'active']
}
</script>

<style lang="scss" scoped>
section {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
}

textarea {
  flex-grow: 1;
}

.sub-btn-holder {
  margin-left: -6px;
  margin-bottom: -7px;
}

/* fix for backface visiblity + textarea scrollbar issue */
.hide-overflow {
  overflow: hidden;
}
</style>
